import { render } from "./TableChannelForm.vue?vue&type=template&id=d5bab8e8"
import script from "./TableChannelForm.vue?vue&type=script&lang=js"
export * from "./TableChannelForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__